var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 126.022,
    viewBox: "0 0 130 126.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-mark-svgrepo-com",
    transform: "translate(0 -7.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M120.363,49.976a2.031,2.031,0,0,0-1.3,2.561,59.128,59.128,0,1,1-12.82-21.769,2.031,2.031,0,0,0,2.979-2.763,62.79,62.79,0,1,0,13.7,23.271A2.032,2.032,0,0,0,120.363,49.976Z",
    fill: "#11b242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M188.2,78.012a6.1,6.1,0,0,0-8.622,0l-1.818,1.818a2.031,2.031,0,1,0,2.873,2.872l1.819-1.819a2.034,2.034,0,1,1,2.875,2.877L115.287,153.8a2.033,2.033,0,0,1-2.875,0L85.058,126.445a2.034,2.034,0,1,1,2.876-2.876l24.479,24.479a2.031,2.031,0,0,0,2.873,0l59.63-59.63a2.031,2.031,0,0,0-2.872-2.873L113.85,143.74,90.808,120.7a6.1,6.1,0,1,0-8.622,8.621l27.353,27.353a6.1,6.1,0,0,0,8.622,0L188.2,86.632a6.1,6.1,0,0,0,0-8.621Z",
    transform: "translate(-59.986 -51.027)",
    fill: "#11b242"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.c0b363013826864c5615d598a7f79c97.svg";
export { ForwardRef as ReactComponent };